import CookieConsent from 'react-cookie-consent'
import { useTranslation } from 'react-i18next';

const CookieBanner = () => {
  const { t } = useTranslation();
  return (
    <CookieConsent
      containerClasses="!bg-primary"
      buttonClasses="!bg-white !rounded-md !text-primary !p-2 !px-4"
      declineButtonClasses="!bg-white !rounded-md !text-primary !p-2 !px-4"
      location="bottom"
      buttonText={t('common:acceptCookies')}
      declineButtonText={t('common:refuseCookies')}
      enableDeclineButton
      expires={150}
    >
      <p>{t('common:cookiesText')}</p>
    </CookieConsent>
  )
  
}

export default CookieBanner
